<template>
<div>
    <div class="login-background">
      <div class="container panel-container-padding">
         <div class="panel shadow border-0 panel-round login-animate">
            <div class="panel-container">
               <div class="row no-gutters">
                  <div class="col-md-6 col-lg-4 col-xl-5 logo-container p-5 d-flex align-items-center">
                     <div class="text-center p-5">
                        <span class="display-1 mb-3">
                           <div class='icon-stack'>
                              <i class="base base-7 icon-stack-3x opacity-100 color-fusion-50"></i> <i class="fas fa-unlock icon-stack-1x opacity-100 color-white"></i>
                           </div>
                        </span>
                        <p class="fw-500 text-left">Please enter your Username and Mobile Number. Your password will be reset and send to you.</p>
                     </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-8 col-xl-7 ml-auto login-padding" style="padding-bottom: 1% !important;">
                     <form @submit.prevent="resetPassword">
                        <h2 class="h1 fw-500 mb-3">Forgot Password</h2>
                        <div class="form-group">
                           <label class="form-label" for="username">Username</label>
                           <div class="input-group">
                              <span class="login-input-icon">
                              <i class="fas fa-user-alt width-1 text-align-center"></i>
                              </span>
                              <input type="text" class="form-control" v-model="username" id="username" name="username" placeholder="Username" required="">
                           </div>
                        </div>
                        <div class="form-group mb-0">
                           <label class="form-label" for="mobile">Mobile</label>
                           <div class="input-group">
                              <span class="login-input-icon">
                                 <i class="fas fa-phone-alt width-1 text-align-center"></i>
                              </span>
                              <input type="text" class="form-control" v-model="mobile" id="mobile" name="mobile" placeholder="mobile" required="" @keyup="contactValidation">
                           </div>
                           <div id="err" class="error-validation"></div>
                        </div>
                        <div class="help-block fs-sm mb-5">
                           <p class="mb-0">Notes:</p>
                           <ul>
                              <li>Malaysia phone number format: 601x xxx xxxx</li>
                              <li>Singapore phone number format: 65x xxx xxxx</li>
                           </ul>
                        </div>
                        <div class="text-left">
                           <button type="submit" class="btn border-0 btn-dark btn-block btn-padding waves-effect waves-themed">Reset Password</button>
                        </div>
                        <div class="mt-2 text-center fs-xs">
                           <i class="fas fa-arrow-left text-secondary mr-2"></i>
                           <router-link to="/login" class="text-secondary" title="Back to Log In Page">Back to Log In Page</router-link>
                        </div>
                     </form>
                     <div class="row mt-5">
                        <div class="col-md-7 col-sm-12 pl-0 pr-0">
                           <p>
                              <small>Contact customer support at
                                 <span class="text-primary fw-500">+60129699748</span>
                              </small>
                           </p>
                        </div>
                        <div class="col-md-5 col-sm-12 pl-0 pr-0 text-right">
                           <p>
                              <small><strong>Copyright</strong> JulyTech © 2018</small>
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div :class="{'show': isModalShow }" class="modal fade">
      <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content pt-3">
               <div class="modal-body d-flex align-items-center">
                  <i class="fas fa-2x" :class="isError ? ['fa-exclamation-circle', 'text-danger'] : ['fa-check-circle', 'text-success']"></i>
                  <p class="ml-3 mb-0" :class="isError ? ['text-danger'] : ['text-success']">{{message}}</p>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-primary waves-effect waves-themed" @click="closeModal">Ok</button>
               </div>
            </div>
      </div>
   </div>
</div>
</template>

<script>
import {contactValidation} from '@/assets/js/dashboard/utilities.js'
export default {
  name: 'forgotPassword',
  data: () => ({
      username: '', mobile: '', isModalShow: false, isError: false, message: ""
    }),
  methods: {
      contactValidation(){
         var err = contactValidation(this.mobile);
         document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
      },
      closeModal(){
         if(!this.isError){
            this.$router.push({ name: 'login' })
         }
         this.isModalShow = false
      },
      resetPassword () {
         let $vm = this;
         var data = {
               username: this.username,
               mobile: this.mobile
         }
         $vm.$axios({
               method: 'post', 
               url: $vm.$api.RESET_PASSWORD,
               baseURL: $vm.$axios.defaults.baseURL, 
               data: data,
         })
         .then((response) => {
            if(response.status == 200){
               $vm.isModalShow = true;
               $vm.isError = false;
               $vm.message = "Your new password has been sent to your mobile."
            }
         })
         .catch((err) => {
            $vm.isModalShow = true;
            $vm.isError = true;
            $vm.message = "System Error."
         })
      }
  }
}
</script>
<style src="@/assets/css/login.css" scoped></style>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
.show{
   display: block;
}
</style>